import PackingListDelivery from "./PackingListDelivery";

export default PackingListDelivery;
